<aside
  class="mobile-sorts-sheet"
  [class.mobile-sorts-sheet--open]="isOpen()">
  <div class="mobile-sorts-sheet__head">
    <h2 class="mobile-sorts-sheet__title">
      {{ 'sorting.sort' | translate }}
    </h2>
    <button
      type="button"
      class="mobile-sorts-sheet__close"
      (click)="close()"
      [attr.aria-label]="'global.close' | translate">
      <i class="iconsax" icon-name="x"></i>
    </button>
  </div>
  <div class="mobile-sorts-sheet__body">
    <ul class="mobile-sorts-sheet__list">
      @for (sort of sorts(); track sort) {
        <li>
          <button
            type="button"
            class="mobile-sorts-sheet__item"
            [class.mobile-sorts-sheet__item--active]="activeSort() === sort.toUpperCase()"
            (click)="selectSort(sort)">
            {{ translateKey() + sort | translate }}
          </button>
        </li>
      }
    </ul>
  </div>
</aside>
